import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommandPaletteItem } from './command-palette.models';
import { CommandPaletteRegistryService } from './command-palette-registry.service';
import { resolveMaterialIconName } from '../navigation/material-icon-fallbacks';

@Component({
  selector: 'app-command-palette',
  templateUrl: './command-palette.component.html',
  styleUrls: ['./command-palette.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommandPaletteComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  query = '';
  activeIndex = 0;
  results: CommandPaletteItem[] = [];

  get activeCommandId(): string | null {
    const command = this.results[this.activeIndex];
    return command ? this.optionId(command) : null;
  }

  constructor(
    private readonly registry: CommandPaletteRegistryService,
    private readonly router: Router,
    private readonly dialogRef: MatDialogRef<CommandPaletteComponent>
  ) {
    this.results = this.registry.search('');
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput?.nativeElement.focus());
  }

  onInput(event: Event): void {
    this.query = (event.target as HTMLInputElement).value || '';
    this.results = this.registry.search(this.query);
    this.activeIndex = 0;
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.moveActive(1);
      return;
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.moveActive(-1);
      return;
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      const command = this.results[this.activeIndex];
      if (command) {
        this.select(command);
      }
    }
  }

  select(command: CommandPaletteItem): void {
    this.dialogRef.close();
    this.router.navigate([command.route]);
  }

  close(): void {
    this.dialogRef.close();
  }

  setActive(index: number): void {
    this.activeIndex = index;
  }

  optionId(command: CommandPaletteItem): string {
    return `command-palette-option-${command.id}`;
  }

  trackCommand(_index: number, command: CommandPaletteItem): string {
    return command.id;
  }

  iconFor(command: CommandPaletteItem): string {
    return resolveMaterialIconName(command.icon);
  }

  private moveActive(delta: number): void {
    if (!this.results.length) {
      this.activeIndex = 0;
      return;
    }
    this.activeIndex = (this.activeIndex + delta + this.results.length) % this.results.length;
  }
}
